import { render, staticRenderFns } from "./FootnoteComponent.vue?vue&type=template&id=76f0e70a&scoped=true"
import script from "./FootnoteComponent.vue?vue&type=script&lang=js"
export * from "./FootnoteComponent.vue?vue&type=script&lang=js"
import style0 from "./FootnoteComponent.vue?vue&type=style&index=0&id=76f0e70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f0e70a",
  null
  
)

export default component.exports